import {Button, OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";

const IconTooltip = ({ id, children, title, action, className}) => (
    <OverlayTrigger overlay={<Tooltip style={{position: 'fixed'}} id={id}>{title}</Tooltip>}>
        <Button onClick={action} className={`${className} bg-transparent border-0`}>{children}</Button>
    </OverlayTrigger>
);

export default IconTooltip